export default __webpack_public_path__ + "static/media/1789.c74f8e21.png";